import { ApiAddress } from "../apis"
import { IPlanPermission } from "../plan-permission/plan-permission.service"
import request from "../request"

export interface ISubscription {
  id: number,
  plan: string,//
  billingFrequency: string, //
  price: number,//
  currency: string,//
  subscriptionStart: number,
  subscriptionEnd: number,//
  paymentMethod: string,
  status: string, //
  uuid: string,
  stripeId: string, //
  trialSart: string,
  trialEnd: string,
  notes: string,
  userId: number,
  email: string
  billingStatus: string
}

export interface CurrentPlanInfo {
  subscription: ISubscription
  permissions: IPlanPermission[]
}

export function getSubscription(): Promise<ISubscription[]> {
  return request.get(ApiAddress.SUBSCRIPTIONS)
}

export function createSubscription(body): Promise<ISubscription> {
  return request.post(ApiAddress.SUBSCRIPTIONS, body)
}

export function getSubscriptionById(id: number): Promise<ISubscription> {
  return request.get(ApiAddress.SUBSCRIPTION_ITEM, {params: {id}})
}

export function deleteSubscription(id: number) {
  return request.delete(ApiAddress.SUBSCRIPTION_ITEM, {params: {id}})
}

export function updateSubscription(body, id: number) {
  return request.put(ApiAddress.SUBSCRIPTION_ITEM, body, {params: {id}})
}

export function getUserSubscription(userId: number): Promise<ISubscription> {
  return request.get(ApiAddress.USER_SUBSCRIPTION_ITEM, {params: {id: userId}})
}

export function getCurrentPlan(): Promise<CurrentPlanInfo> {
  return request.get(ApiAddress.CURRENT_PLAN)
}

export function cancelMySubscription() {
  return request.delete(ApiAddress.CANCEL_MY_SUBSCRIPTION)
}
